// extracted by mini-css-extract-plugin
export default {"itemLocked":"RoleItem_itemLocked__bZ0uT"};